var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"demo"}},[_c('div',{},[_c('div',{ref:"scroll",staticClass:"table-box"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }